import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ServiceMain from "./ServiceMain";

const Service = () => (
  <>
    <Header />
    <ServiceMain />
    <Footer />
  </>
);

export default Service;
